import './map-card.css';

function MapCard({ children, className = '' }) {
  return (
    <div className={`map-card ${className}`.trim()}>
      {children}
    </div>
  );
}

export default MapCard;
